import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '@core/types';
import { MenuActionService } from 'app/helpers/menu-action.service';
import { isImageIcon, isLucideIcon, lucideIconName } from '@core/utils';

@Component({
    selector: '[core-menu-vertical-item]',
    templateUrl: './item.component.html',
    standalone: false
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;

  /** Expone el helper al template: el icono puede ser clase o imagen */
  readonly isImageIcon = isImageIcon;

  /** Los iconos elegidos del catálogo se guardan como 'lucide:<nombre>' */
  readonly isLucideIcon = isLucideIcon;
  readonly lucideIconName = lucideIconName;

  constructor(private _menuActionService: MenuActionService) {}

  /**
   * Ejecuta la opción de tipo acción en lugar de navegar
   * @param event Clic sobre el item
   */
  runAction(event: Event): void {
    event.preventDefault();
    this._menuActionService.run(this.item);
  }
}
